<div class="page">
  <header class="hero">
    <div class="hero__copy">
      <p class="hero__eyebrow">Article manager</p>
      <h1 class="hero__title">文章管理</h1>
      <p class="hero__description">快速查找、编辑和维护你的 Markdown 文章。</p>
    </div>

    <div class="hero__actions">
      <button
        class="button button--ghost"
        type="button"
        (click)="fetchList()"
        [disabled]="fetching"
      >
        <mat-icon [class.anmi-pluse]="fetching">cached</mat-icon>
        <span>{{ fetching ? "刷新中" : "刷新" }}</span>
      </button>

      <button
        class="button button--primary"
        type="button"
        (click)="newPost()"
        [disabled]="creating"
      >
        <mat-icon [class.anmi-pluse]="creating">add</mat-icon>
        <span>{{ creating ? "创建中" : "新建文章" }}</span>
      </button>
    </div>
  </header>

  <main class="page__content">
    <section class="toolbar" aria-label="文章筛选工具栏">
      <div class="toolbar__search">
        <mat-icon>search</mat-icon>
        <input
          type="search"
          placeholder="搜索标题、摘要、正文或标签"
          [value]="searchTerm"
          (input)="handleSearch($event)"
        />
        <button
          class="toolbar__clear"
          type="button"
          *ngIf="searchTerm"
          (click)="clearSearch()"
          aria-label="清空搜索"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="toolbar__stats" aria-label="文章统计">
        <span class="stat">
          <strong>{{ posts.length }}</strong>
          全部
        </span>
        <span class="stat stat--success">
          <strong>{{ publishedCount }}</strong>
          已发布
        </span>
        <span class="stat stat--muted">
          <strong>{{ draftCount }}</strong>
          草稿
        </span>
      </div>
    </section>

    <div class="state state--error" *ngIf="errorMessage">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
      <button type="button" (click)="fetchList()">重试</button>
    </div>

    <div class="state" *ngIf="fetching && !hasPosts">
      <mat-spinner diameter="28"></mat-spinner>
      <span>正在加载文章列表...</span>
    </div>

    <section
      class="empty"
      *ngIf="!fetching && hasPosts && filteredPosts.length === 0"
      aria-live="polite"
    >
      <mat-icon>manage_search</mat-icon>
      <h2>没有匹配的文章</h2>
      <p>换个关键词试试，或清空搜索条件查看全部文章。</p>
      <button
        class="button button--ghost"
        type="button"
        (click)="clearSearch()"
      >
        清空搜索
      </button>
    </section>

    <section class="empty" *ngIf="!fetching && !hasPosts" aria-live="polite">
      <mat-icon>note_add</mat-icon>
      <h2>还没有文章</h2>
      <p>创建第一篇文章，开始记录你的想法。</p>
      <button class="button button--primary" type="button" (click)="newPost()">
        新建文章
      </button>
    </section>

    <section class="post-grid" *ngIf="filteredPosts.length > 0">
      <article
        class="post-card"
        *ngFor="let post of filteredPosts; trackBy: trackByPostId"
        (click)="handlePostCardClick(post.post_id)"
        (keydown.enter)="handlePostCardClick(post.post_id)"
        (keydown.space)="
          $event.preventDefault(); handlePostCardClick(post.post_id)
        "
        tabindex="0"
        role="button"
        [attr.aria-label]="'编辑文章：' + (post.title || '未命名文章')"
      >
        <div class="post-card__topline">
          <span
            class="post-card__status"
            [class.post-card__status--published]="post.is_published"
          >
            {{ post.is_published ? "已发布" : "草稿" }}
          </span>
          <span class="post-card__date" *ngIf="post.last_update_datetime">
            {{ post.last_update_datetime | date: "yyyy/MM/dd HH:mm" }}
          </span>
        </div>

        <h2 class="post-card__title">{{ post.title || "未命名文章" }}</h2>
        <p class="post-card__description">
          {{
            post.description ||
              (post.content | slice: 0:120) ||
              "暂无摘要，点击补充文章内容。"
          }}
        </p>

        <div class="post-card__tags" *ngIf="post.tags && post.tags.length">
          <span class="tag" *ngFor="let tag of post.tags | slice: 0:3"
            >#{{ tag }}</span
          >
        </div>

        <div class="post-card__footer">
          <a
            class="post-card__edit"
            [routerLink]="['/edit', post.post_id]"
            (click)="$event.stopPropagation()"
          >
            编辑
            <mat-icon>arrow_forward</mat-icon>
          </a>

          <button
            class="post-card__delete"
            type="button"
            *ngIf="post.post_id"
            (click)="deletePost($event, post)"
            [disabled]="isBusy"
            [attr.aria-label]="'删除文章：' + (post.title || '未命名文章')"
          >
            <mat-icon [class.anmi-pluse]="deletingPostId === post.post_id">
              {{ deletingPostId === post.post_id ? "sync" : "delete_outline" }}
            </mat-icon>
          </button>
        </div>
      </article>
    </section>
  </main>
</div>
